export default "__VITE_ASSET__Dkto0P9v__"